<agr-dialog [data]="data" [verticalSpacing]="true" (cancel)="cancel()" class="cow-details">
  <app-cow-details [internationalCowId]="internationalCowId"></app-cow-details>
</agr-dialog>
